import {MUTATION_KEYS, QUERY_KEYS} from '@/queryClient'
import {httpDeliverySubtitles} from '@/features/videos/services/video.http'
import {useMutation, useQueryClient} from '@tanstack/react-query'

export interface DeliveryRequest {
    projectId: string
    jobId: string
    workspaceId: string
    onSuccess: () => void
}

export const useDeliverSubtitles = ({projectId, jobId, workspaceId, onSuccess}: DeliveryRequest) => {
    const client = useQueryClient()
    return useMutation({
        mutationKey: [MUTATION_KEYS.DELIVERY_SUBTITLES],
        mutationFn: () => httpDeliverySubtitles(workspaceId, projectId, jobId),
        onSuccess: () => {
            onSuccess()
            client.invalidateQueries({queryKey: [QUERY_KEYS.WORKSPACE_VIDEO_DETAILS, workspaceId, projectId]})
            client.invalidateQueries({queryKey: [QUERY_KEYS.JOB_STATUS_HISTORY, projectId]})
        }
    })
}
